calendars-date-ui
  .row
    .col-12
      .ui-wrap.form-inline
        .prev-day.btn.btn-outline-success.btn-sm(onClick="{onClickPrev2Weeks}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().prev2Weeks}") <
        .prev-day.btn.btn-outline-success.btn-sm(onClick="{onClickPrevWeek}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().prevWeek}") <
        .date-wrap
          input.form-control(name="" value="{ start }" onInput="{this.onInput}" onChange="{this.onChange}" data-type="date")
        .next-day.btn.btn-outline-success.btn-sm(onClick="{onClickNextWeek}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().nextWeek}") >
        .next-day.btn.btn-outline-success.btn-sm(onClick="{onClickNext2Weeks}" data-toggle="tooltip" data-placement="top" data-original-title="{this.locale().next2Weeks}") >
  script(type="typescript").
    this.mixin('calendars.date-ui');
